<template>
  <div>
  <b-navbar  class="barr px-12 py-4"  toggleable="sm"  >

    <b-navbar-brand  id="comune">Comune di {{comnome}}</b-navbar-brand>

  <!-- <b-navbar-toggle v-if="backofficeHead!==''" target="nav-text-collapse"></b-navbar-toggle> -->

    <!-- <b-collapse

    id="nav-text-collapse"
    is-nav> -->
      <b-navbar-nav class="navtext px-2" v-if="backofficeHead!==''">
        <span  @click="switchArchivio()" class="navtext" >{{backofficeHead}}</span>
        </b-navbar-nav>
    <!-- </b-collapse> -->
  </b-navbar>
</div>
</template>

<script>

export default {
  name: 'navbar',

  data () {
    return {
      comnome: this.$store.getters.getComune.nome,
      backofficeHead: this.$store.getters.backoffice
    }
  },
  methods: {
    switchArchivio () {
      this.$store.dispatch('swithArchivio', this.backofficeHead)
    }
  },
  computed: {
    backoffice () { return this.$store.getters.backoffice },
    comune () { return this.$store.getters.getComune }
  },
  mounted () {
    this.comnome = this.comune.nome
    console.log('header title', this.comnome)
  },
  watch: {
    $route: function (rot) {
      console.log('root -->', rot)
      this.comnome = this.$store.getters.getComune.nome
    },
    comune (com) {
      this.comnome = com.nome
      console.log('header title', this.comnome)
    },
    backoffice (newbch, oldbch) {
      console.log(oldbch, ' -->', newbch)
      if (newbch) {
        this.backofficeHead = newbch
      }
    }
  }
}
</script>
